<template>
  <el-row>

    <a target="_blank"
             class="download-button" style="float:right"
             :href="axios.defaults.baseURL + '/markets/' +  this.$route.params.userID + '/downloadAll?year=' + this.selectedYear+`&token=${token}`">
             Download All<i class="el-icon-download"></i>
    </a>


    <el-table :data="marketDocumentList"
              style="width: 100%">
      <el-table-column prop="name"
                       label="File Name">
      </el-table-column>
      <el-table-column fixed="right"
                       header-align="center"
                       align="center"
                       label="Operations"
                       width="140">
        <template slot-scope="scope">
          <a target="_blank"
             class="download-button"
             :href="scope.row.url+`&token=${token}`">
            <i class="el-icon-download"></i>
          </a>
        </template>
      </el-table-column>
    </el-table>
  </el-row>
</template>

<script>
export default {
  created() {
    this.getFiles();
  },
  data() {
    return {
      headers: { Authorization: 'Bearer ' + localStorage.token },
      marketDocumentList: [],
      token: localStorage.token,
      tabs: [],
      selectedYear: ""
    };
  },
  methods: {
    getTabs() {
        this.tabs = [];
        if(this.marketDocumentList === undefined){
          return;
        }
        
        var re1 = /20\d{2}\d*/g;
        //let re2 = RegExp('^(20\\d{2})\\D', 'g');
        var years = [];
        this.marketDocumentList.forEach((file) => {
          //file.name = 'd2019 2018kkk201999gg201 aa'
          //console.log(file.name);
          var year = new String();
          while (year = re1.exec(file.name)) {
            if(year[0].length == 4 && years.indexOf(year[0])< 0){
              years.push(year[0])
            }
          }
        });
        years.sort();
        years.reverse();
//        this.tabs.push()
        years.forEach((yy) => {
            this.tabs.push({name: yy, year: yy});
        });
        this.tabs.push({name: 'All', year: ''});
    },
    getFiles() {
      this.axios({
        method: 'get',
//        url: this.axios.defaults.baseURL + `/templates/${this.$route.params.userID}`,
        url: `/markets/${this.$route.params.userID}`,
      }).then(res => {
        //console.log('abcd');
        this.marketDocumentList = res.data.files;
        this.getTabs();
      });
    },
    viewFile(row) {
      this.axios({
        method: 'get',
        url: row.url,
        responseType: 'blob',
      }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', row.name);
        document.body.appendChild(link);
        link.click();
      });
    },

    handleChange() {},
  },
};
</script>

<style lang="scss" scoped>
@import 'theme/element-variables';
.download-button {
  color: #ffffff;
  background-color: $--color-primary;
  border: 1px solid $--color-primary;
  border-radius: 3px;
  padding: 9px 15px;
  font-size: 12px;
  display: inline-block;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/user/MarketDocumentList.vue